import { render } from "./StakingFlows.vue?vue&type=template&id=474fc279&scoped=true"
import script from "./StakingFlows.vue?vue&type=script&lang=js"
export * from "./StakingFlows.vue?vue&type=script&lang=js"

import "./StakingFlows.vue?vue&type=style&index=0&id=474fc279&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474fc279"],['__file',"resources/js/components/StakingFlows.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "474fc279"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('474fc279', __exports__)) {
    api.reload('474fc279', __exports__)
  }
  
  module.hot.accept("./StakingFlows.vue?vue&type=template&id=474fc279&scoped=true", () => {
    api.rerender('474fc279', render)
  })

}


export default __exports__